import styled from 'styled-components';

export const CustomTabPanelWrapper = styled.div`
  width: 100%;
  padding-top: 1rem;
`;
